import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";

export const AddEditProductSchema = yup.object({
  productName: yup
    .string()
    .trim()
    .required(BASIC_AUTHENTICATION_ERROR.PRODUCT_NAME_REQUIRED),
  Categories: yup
    .array()
    .required(BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED)
    .min(1, BASIC_AUTHENTICATION_ERROR.CATEGORIES_REQUIRED),
  status: yup.string().required(BASIC_AUTHENTICATION_ERROR.STATUS_REQUIRED),
  tags: yup
    .array()
    .required(BASIC_AUTHENTICATION_ERROR.TAGS_REQUIRED)
    .min(1, BASIC_AUTHENTICATION_ERROR.TAGS_REQUIRED),
  description: yup
    .string()
    .transform((value, originalValue) =>
      originalValue.trim() === "" ? null : value
    )
    .trim()
    .nullable()
    .notRequired()
    .min(4, BASIC_AUTHENTICATION_ERROR.DESCRIPTION_MIN_REQUIRED)
    .max(500, BASIC_AUTHENTICATION_ERROR.DESCRIPTION_MAX_REQUIRED),
  price: yup
    .number()
    .typeError(BASIC_AUTHENTICATION_ERROR.PRICE_REQUIRED)
    .required(BASIC_AUTHENTICATION_ERROR.PRICE_REQUIRED)
    .positive(BASIC_AUTHENTICATION_ERROR.PRICE_POSITIVE)
    .max(99999, BASIC_AUTHENTICATION_ERROR.PRICE_MAX_ALLOWED),
  quantity: yup
    .number()
    .typeError(BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_REQUIRED)
    .required(BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_REQUIRED)
    .min(0, BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_MAX_LIMIT)
    .integer(BASIC_AUTHENTICATION_ERROR.TOTAL_QUANTITY_REQUIRED),
  productMedia: yup
    .array()
    .min(1, "Media file is mandatory.")
    .required("Media is required"),
  // variantTypes: yup - removed from validation for now
});

